import { useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { QueryKeys } from '../queryKeys';
const EMPTY_TAX_RATES = [];
export const useAccountingTaxRates = function useAccountingTaxRates(integration) {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const { data, isLoading } = useQueryState({
        queryKey: [
            QueryKeys.AccountingTaxRates,
            integration
        ],
        queryFn: ()=>api.accounting.getTaxRates({
                integration
            }),
        enabled,
        refreshOnHookMount
    });
    return {
        taxRates: data !== null && data !== void 0 ? data : EMPTY_TAX_RATES,
        isLoading
    };
};
